import React from 'react'
import PropTypes from 'prop-types'
import { Visibility } from '@material-ui/icons'
import { Button } from 'ui-components/Button'
import { DescItemList } from 'ui-components/DescItemList'
import { DescList } from 'ui-components/DescList'
import { Container } from './styles'

export default function PaymentMethod({ paymentMethod, onClick }) {
  const handleClick = () => {
    onClick(paymentMethod)
  }

  return (
    <DescList>
      <Container>
        <DescItemList label="Nome">
          {paymentMethod.attributes.name}
        </DescItemList>
        <Button buttonType="icon" onClick={handleClick}>
          <Visibility />
        </Button>
      </Container>
    </DescList>
  )
}

PaymentMethod.propTypes = {
  paymentMethod: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
}
